import { combineReducers } from "redux";
import { modals } from "./modals";
import { tracks } from "./tracks";

export default combineReducers({
  modals: modals,
  tracks: tracks,
});
